import React from 'react';
import { Col, Row } from 'antd';


const BottomFaq = () => {
    return (
        <div>

            <section className="question-area ptb-70">
                <div className="container">
                    <Row gutter={20}>
                        <Col md={24} className="mb-3">
                            <h2>Get the Cheapest Flight Ticket Only At SuperbWorldTrip!</h2>
                            <p>
                                SuperbWorldTrip is your ultimate companion to only provide you with a cheap flight ticket but also
                                with courteous services to make your trip convenient and hassle-free. Flight ticket booking and
                                hotel booking can be a hectic and time-consuming tasks while planning for the trip. That's why
                                SuperbWorldTrip provides a handy flight insight platform along with the best customize holiday
                                packages through which you can enjoy your journey without any hassle. We offer exclusive deals,
                                cheap Flight booking fares, domestic and international flight deals, and round the clock
                                customer service. So, what is stopping you from exploring the world and take a break from a
                                hectic life? Reach out to us to avail yourself of an air ticket at a reasonable price and
                                one-stop solutions for your solutions.
                            </p>
                        </Col>
                        <Col md={24} className="mb-3">
                            <h2>Get Domestic and International Flight Ticket Booking at the Cheapest Price!</h2>
                            <p>
                                Are you looking for a cheap Delhi to Bangalore flight? Are you searching for last-minute deals
                                for Patna to Delhi flights? Don't worry! Here at SuperbWorldTrip, you can get affordable flights to
                                all the possible destinations across India. So, if you want to travel to any domestic
                                destination, you can find the best suitable getaway for your trip. This is the best platform for
                                you to get exclusive deals for your desired place.
                            </p>
                            <p>
                                If you love traveling and want to explore the world without hurting your pocket, you are on the
                                apt ticket booking platform. With us, you can find affordable international flight bookings to
                                plan your trip to your aspired destination across the world. Along with plane tickets within
                                your budget, you can get reasonable holiday packages to make your trip more convenient and
                                hassle-free.
                            </p>
                        </Col>
                        <Col md={24} className="mb-3">
                            <h2>Why Book Air ticket With SuperbWorldTrip? Know Here!</h2>
                            <p>
                                SuperbWorldTrip is one of the leading and most convenient domestic flights and International flight
                                booking platforms. With us, you can find plenty of affordable packages, easy-to-use flight
                                insight, exclusive deals & offers, and end-to-end support to book your trip without any hurdle.
                                Whether you need assistance with <strong>'book my ticket'</strong> or want to avail a perfect
                                holiday getaway within your budget, you can count on us. However, here are some reasons why you
                                should use our cheap flight booking platform:
                            </p>
                        </Col>
                        <Col md={12} className="mb-3">
                            <h2>1. Get Complete and Affordable Holiday Packages</h2>
                            <p>
                                Planning a trip is not only about cheap flight tickets or cheap plane tickets but also includes
                                hotel accommodation and other conveyance at the desired destination. That's why to make it easy
                                for our explorers, we offer complete packages for your trip at a reasonable price.
                            </p>
                        </Col>
                        <Col md={12} className="mb-3">
                            <h2>2. Secure Cheap flight tickets</h2>
                            <p>
                                Through our convenient booking portal, you can get cheap deals to grab international and domestic
                                flights. We serve you with the most reliable and transparent services to make your traveling
                                dream come true.
                            </p>
                        </Col>
                        <Col md={12} className="mb-3">
                            <h2>3. Exciting deals and Offers</h2>
                            <p>
                                Avail of our amazing exclusives deals, season sales, and huge discounts to make your trip cheaper
                                and more amusing. With our motto to make air travel convenient for everyone, we provide
                                affordable <strong>air travel booking</strong> to our wanderers.
                            </p>
                        </Col>
                        <Col md={12}>
                            <h2>4. Helpful Customer Support</h2>
                            <p>
                                We know that booking plane tickets online can be a challenging task. Therefore to reduce your
                                stress, our experts are always available at the helpdesk for you. You can get end-to-end support
                                to grab deals and book your flight ticket at the best price.
                            </p>
                        </Col>
                    </Row>
                </div>

            </section>

        </div>
    )
}

export default BottomFaq
